// extracted by mini-css-extract-plugin
module.exports = {"Button":"style-module--Button--3vTt7","disable":"style-module--disable--1Gv5T"};